export default "__VITE_ASSET__APk7shff__"